import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Prioritising can help to make sense of the potential choices
                                                we can make. The prioritising process
                                                is vital to many different aspects of our life and by doing
                                                so effectively you can plan ahead with
                                                more confidence. This tool is about <span
                                                    className="green brownbold">how to prioritise tasks ready for action</span> and
                                                introduces you
                                                to the concept of prioritising and how you can learn to do
                                                it effectively.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                HOW TO PRIORITISE
                </span></div>
                                            <div className="border_subtitle">Why prioritise?</div>
                                            <p>There are too many things to do. There will always be too
                                                many things to do. As you progress in
                                                your career, the likelihood is that there will usually be
                                                far more ‘too many things to do’.</p>
                                            <p>I am sure you have heard people say, ‘If only there were more
                                                hours in the day, then I could get
                                                my work done’. But they’d be wrong – if you approach your
                                                tasks hoping that somehow the laws
                                                of physics will yield to allow you to meet a deadline, then
                                                you need to pay attention now!</p>

                                            <p>You are also likely to have heard people say, ‘too much to
                                                do, not enough time to do it in’. Well, at
                                                least these people are a bit more realistic. They know that
                                                people in organisations have many
                                                things to do, but they still sound as if they’re struggling
                                                to do everything asked of them, all at
                                                once. To be able to cope with the demands placed on you, you
                                                need to be able to prioritise.</p>
                                            <p>By the way, if you think you can already prioritise your
                                                tasks effectively then you really should
                                                have stopped reading this by now – continuing is a low
                                                priority for you!</p>
                                            <div className="border_subtitle">How to prioritise tasks</div>
                                            <div className="uiheading sept"><p>There are two key questions
                                                to ask yourself when you have tasks to prioritise:</p>
                                            </div>

                                            <ol className="blackOL list-sep">
                                                <li>How important is the task?<br/><span><p
                                                    style={{paddingTop:'0px !important'}}>What does ‘important’ mean? A useful way to look at this is to think about what you get rewarded
for in your job. You need to ensure that you focus your efforts on activities that are valued by
your organisation and that your role is designed to deal with.</p>
                        <p>A common mistake is to focus on tasks you like doing or find easy – but if these aren’t the ones
for which you are rewarded, then they’re less important.
                        </p>
                        <p style={{paddingBottom: '0px !important'}}>Importance is all about asking ‘what do I want to get from my job?’. If you want to develop
specific skills, then tasks requiring them will become important to you. There is also a need to
balance tasks at work that we find rewarding and those that will help with our future development.
                        </p></span></li>
                                            </ol>

                                            <ol className="blackOL list-sep" start="2">
                                                <li>How urgent is the task?<br/><span><p
                                                    style={{paddingTop:'0px !important'}}>Urgency depends on when the task needs to be completed. Generally, the sooner the deadline,
the more urgent the task. Don’t fall into the trap of confusing urgency with importance. If you
prioritise on the basis of urgency alone, you might not complete other, important tasks.</p>
                       </span></li>
                                            </ol>

                                            <div className="circle_title pad-separate"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                PRIORITISATION EXERCISE
                </span></div>
                                            <p>
                                                This exercise helps you put the ideas discussed here into
                                                practice.</p>
                                            <div className="border_subtitle">Step 1</div>
                                            <p>The first step is to think about importance. To do this you
                                                need to think about what you want to
                                                achieve from your job. Once you have done this, you need to
                                                think about the type of tasks that
                                                will help you achieve your objectives. It is important you
                                                carry out this step before you prioritise
                                                your tasks, otherwise there will be little meaning to the
                                                way you prioritise.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}